(function ($) {
  $(document).ready(function () {
    $('.js-acc__body').hide();
    $('.js-acc').on("click", function () {
      $(this).toggleClass('js-acc--open')
      $(this).next('.js-acc__body').slideToggle(400);
      return false;
    });
  });
})(jQuery);
